/**
 * JSON-LD nodes for the agency itself (ConstructionWebDesign.uk), shared by the
 * site-wide graph and the directory graphs so every page links to the same
 * @id. The agency is an Organization + ProfessionalService: never a
 * construction business. Safe to import anywhere.
 */

import { SITE } from "@/lib/site";

export const ORGANIZATION_ID = `${SITE.url}#organization`;
export const WEBSITE_ID = `${SITE.url}#website`;

export function agencyNode() {
  return {
    "@type": ["Organization", "ProfessionalService"],
    "@id": ORGANIZATION_ID,
    name: SITE.brand,
    url: SITE.url,
    logo: `${SITE.url}/favicon.svg`,
    image: `${SITE.url}/og.jpg`,
    email: SITE.email,
    sameAs: [SITE.social.linkedin],
    priceRange: "££",
    address: {
      "@type": "PostalAddress",
      addressLocality: SITE.city,
      addressCountry: "GB",
    },
    areaServed: { "@type": "Country", name: "United Kingdom" },
    contactPoint: [
      {
        "@type": "ContactPoint",
        contactType: "sales",
        email: SITE.email,
        areaServed: "GB",
        availableLanguage: ["English"],
      },
    ],
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        opens: "09:00",
        closes: "18:00",
      },
    ],
    description:
      "ConstructionWebDesign.uk is a UK web design agency that only builds websites for construction companies and trades. Based in London, working with construction firms across the UK. Websites cost £1,000 fixed and go live in 7 days.",
  };
}

export function websiteNode() {
  return {
    "@type": "WebSite",
    "@id": WEBSITE_ID,
    url: SITE.url,
    name: SITE.brand,
    publisher: { "@id": ORGANIZATION_ID },
    inLanguage: "en-GB",
  };
}
